import { useState, useRef } from 'react';
import axios from 'axios';
import qs from 'qs';

export default function useHttpStatus({
  onPending = () => {},
  onSuccess = () => {},
  onError = () => {},
  progress = false,
} = {}) {
  const fetched = useRef(undefined);
  const [prog, setProg] = useState(0);
  const [res, setRes] = useState({
    status: null,
    payload: null,
  });
  const count = useRef(0);

  const req = async (args) => {
    const k = count.current + 1;

    count.current = k;
    onPending();
    setRes({ status: 'pending', payload: null });

    try {
      const r = typeof args === 'function'
        ? await args()
        : await axios({
          timeout: 2 * 60 * 1000,
          ...args,
          paramsSerializer: (params) => (
            qs.stringify(params)
          ),
          ...(progress ? {
            onUploadProgress(e) {
              setProg(e.loaded / e.total);
            },
          } : {}),
        });

      // if there is a newer request
      if (count.current !== k) return null;

      // retain pervious fetched payload
      fetched.current = r.data;

      // callback
      onSuccess(r);

      const re = {
        status: 'success',
        payload: r.data,
        code: r.status,
      };

      setRes(re);

      return re;
    } catch (err) {
      // if there is a newer request
      if (count.current !== k) return null;

      const { response, message, code } = err;
      let payload;

      if (message === 'Network Error') {
        payload = '噢！無法連接伺服器 :(';
      } else if (code === 'ECONNABORTED') {
        payload = '連接伺服器逾時';
      } else {
        payload = response?.data;
      }

      // callback
      onError(err);

      const re = {
        status: 'error',
        payload,
        code: response ? response.status : null,
      };

      setRes(re);

      return re;
    }
  };

  return [res, req, fetched.current, prog];
}
